import React, { Fragment } from "react";
import { Call as CallIcon } from "@mui/icons-material";

const Footer = ({ phoneNumber }) => {
  return (
    <Fragment>
      <footer className="bg-custom-yellowLight py-16">
        <div className="max-w-[960px] mx-auto px-4 tab:px-0">
          <img
            src="/images/logo.png"
            className="w-80 mx-auto h-auto"
            alt="Logo"
          />
          <div className="mt-12 text-custom-primary font-normal">
            <h3 className="text-[15px] font-bold mb-4">
              © {new Date().getFullYear()}, Debt Redemption, All Rights
              Reserved.
            </h3>
            <p className="text-xs text-justify">
              *Debt Redemption’s performance (settlement) fees are 15% versus up
              to 25% charged by many out-of-state competitors. Debt Redemption
              is not a lender but offers an affiliate platform to receive loan
              offers from multiple lenders. Clients who are able to remain with
              the program and resolve all their debts generally experience an
              approximate 45% reduction of their enrolled balance before our
              performance fee of 15%, a $9.95 monthly bank fee, and any optional
              third-party fees. Individual results may vary based on the ability
              to save sufficient funds, the ability to complete the program, and
              the creditors enrolled. Statements made are examples of past
              performance and are not intended to be a guarantee that your debt
              balances will be lowered by a specific amount or percentage or
              that you will be debt-free within a specific time period.
              Settlement fees are not charged until a debt is reduced and
              payment has been made to a creditor. The use of debt settlement
              services will likely adversely affect your creditworthiness, may
              result in you being subject to collections or being sued by
              creditors or collectors, and may increase the outstanding balances
              of your enrolled accounts due to the accrual of fees and interest.
              We do not assume consumer debt, make monthly payments to
              creditors, or provide tax, bankruptcy, accounting, or legal
              advice. We do not provide credit repair services. For answers to
              common questions, please visit our FAQs page. Optional separate
              legal services may be offered by attorneys or legal plan providers
              and all associated fees are paid directly to the providers. Please
              contact a tax professional to discuss any possible tax
              consequences of paying less than the full balance. Programs are
              only available in Texas. Logos used are the property of their
              respective owners.
            </p>
            <div className="flex justify-center items-center gap-10 mt-8">
              <a
                className="text-sm underline font-light"
                href="/privacy-policy"
              >
                Privacy Policies
              </a>
              <a
                className="text-sm underline font-light"
                href="/privacy-policy"
              >
                Terms Of Site
              </a>
              <a
                className="text-sm underline font-light"
                href="/privacy-policy"
              >
                Disclaimer
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="bg-custom-primaryDark py-8 px-[4%] flex max-sm:flex-col gap-2 sm:items-center justify-between">
        <a
          className="text-lg text-white font-light"
          href={`tel:${phoneNumber}`}
        >
          <CallIcon className="mb-1" />
          {phoneNumber}
        </a>
        <div className="flex items-center">
          <img src="/images/location.png" className="w-6 me-2" alt="Location" />
          <p className="text-base font-normal text-white">Service Areas</p>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
